<template>
  <div class="row">
    <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
      <div class="sm-info-container">
        <div class="sm-info" v-if="building.usage">
          <meta-info :title="$t('building_page.usage')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">
              <div v-if="building.usage && building.usage.length > 0">{{ usage }}</div>
              <div v-else>---</div>
            </div>
            <div slot="en">
              <div v-if="building.usage && building.usage.length > 0">{{ usage }}</div>
              <div v-else>---</div>
            </div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.grade">
          <meta-info :title="$t('building_page.grade')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">
              <div v-if="building.grade">{{ $t(`building_page.grade${building.grade}`) }}</div>
              <div v-else>---</div>
            </div>
            <div slot="en">
              <div v-if="building.grade">{{ $t(`building_page.grade${building.grade}`) }}</div>
              <div v-else>---</div>
            </div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.inTakeDate">
          <meta-info :title="$t('building_page.inTakeDate')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ inTakeDate }}</div>
            <div slot="en">{{ inTakeDate }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.title">
          <meta-info :title="$t('building_page.title')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ title }}</div>
            <div slot="en">{{ title }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.numberOfBuilding">
          <meta-info :title="$t('building_page.numberOfBuildings')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ numberOfBuildingsZh }}</div>
            <div slot="en">{{ numberOfBuildingsEn }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.numberOfFloors">
          <meta-info :title="$t('building_page.numberOfFloors')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ numberOfFloorZh }}</div>
            <div slot="en">{{ numberOfFloorEn }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.totalArea">
          <meta-info :title="$t('building_page.totalArea')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ totalAreaZh }}</div>
            <div slot="en">{{ totalAreaEn }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.numberOfPassengerLift">
          <meta-info :title="$t('building_page.numberOfPassengerLift')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ numberOfPassengerLiftZh }}</div>
            <div slot="en">{{ numberOfPassengerLiftEn }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.numberOfCargoLift">
          <meta-info :title="$t('building_page.numberOfCargoLift')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ numberOfCargoLiftZh }}</div>
            <div slot="en">{{ numberOfCargoLiftEn }}</div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="raisedFloorContent !== 'noProvided'">
          <meta-info :title="$t('building_page.raisedFloor')" :title-style="titleStyle" class="sm-meta">
            <div slot="zh">
              <img v-if="raisedFloorContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="raisedFloorContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="raisedFloorContent === 'noProvided'">---</span>
            </div>
            <div slot="en">
              <img v-if="raisedFloorContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="raisedFloorContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="raisedFloorContent === 'noProvided'">---</span>
            </div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="carParkContent !== 'noProvided'">
          <meta-info :title="$t('building_page.carPark')" :title-style="titleStyle" class="sm-meta">
            <div slot="zh">
              <img v-if="carParkContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="carParkContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="carParkContent === 'noProvided'">---</span>
            </div>
            <div slot="en">
              <img v-if="carParkContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="carParkContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="carParkContent === 'noProvided'">---</span>
            </div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="loadingAreaContent !== 'noProvided'">
          <meta-info :title="$t('building_page.loadingArea')" :title-style="titleStyle" class="sm-meta">
            <div slot="zh">
              <img v-if="loadingAreaContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="loadingAreaContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="loadingAreaContent === 'noProvided'">---</span>
            </div>
            <div slot="en">
              <img v-if="loadingAreaContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="loadingAreaContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="loadingAreaContent === 'noProvided'">---</span>
            </div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="cargoContent !== 'noProvided'">
          <meta-info :title="$t('building_page.cargo')" :title-style="titleStyle" class="sm-meta">
            <div slot="zh">
              <img v-if="cargoContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="cargoContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="cargoContent === 'noProvided'">---</span>
            </div>
            <div slot="en">
              <img v-if="cargoContent === 'YES'" :src="yesIcon" class="icon" />
              <img v-if="cargoContent === 'NO'" :src="noIcon" class="icon" />
              <span v-if="cargoContent === 'noProvided'">---</span>
            </div>
          </meta-info>
        </div>
        
        <div class="sm-info" v-if="building.airConditioning">
          <meta-info
            :title="$t('building_page.airConditioning')"
            :title-style="titleStyle"
            class="lg-meta"
          >
            <div slot="zh">
              <div v-if="building.airConditioning && building.airConditioning.length > 0"
                   v-for="airCondition in building.airConditioning">
                {{ $t(`building_page.${airCondition}`) }}
              </div>
              <div v-if="!building.airConditioning || building.airConditioning.length == 0">
                ---
              </div>
            </div>
            <div slot="en">
              <div v-if="building.airConditioning && building.airConditioning.length > 0"
                   v-for="airCondition in building.airConditioning">
                {{ $t(`building_page.${airCondition}`) }}
              </div>
              <div v-if="!building.airConditioning || building.airConditioning.length == 0">
                ---
              </div>
            </div>
          </meta-info>
        </div>
        
        <div class="flex-info" v-if="building.managementFeeZh">
          <meta-info :title="$t('building_page.managementFee')" :title-style="titleStyle">
            <div slot="zh">
              {{ managementFeeZh }}
              <span v-if="managementFeeSourceZh" class="management-fee-source">(資料年份: {{ managementFeeSourceZh }})</span>
            </div>
            <div slot="en">
              {{ managementFeeEn }}
              <span v-if="managementFeeSourceEn" class="management-fee-source">(Information: Year {{ managementFeeSourceEn }})</span>
            </div>
          </meta-info>
        </div>
        
        <div class="flex-info" v-if="building.transportZh">
          <meta-info :title="$t('building_page.transport')" :title-style="titleStyle">
            <div slot="zh">{{ transportContentZh }}</div>
            <div slot="en">{{ transportContentEn }}</div>
          </meta-info>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5">
      <div class="row">
        <div class="col-xs-12" v-if="building.managementCompanyZh">
          <meta-info :title="$t('building_page.managementCompany')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">{{ managementCompanyZh }}</div>
            <div slot="en">{{ managementCompanyEn }}</div>
          </meta-info>
        </div>
        
        <div class="col-xs-12" v-if="building.ceilingHeightZh">
          <meta-info :title="$t('building_page.ceilingHeight')" :title-style="titleStyle" class="meta-info">
            <div class="remark-string" slot="zh">{{ ceilingHeightZh }}</div>
            <div class="remark-string" slot="en">{{ ceilingHeightEn }}</div>
          </meta-info>
        </div>
        
        <div class="col-xs-12" v-if="building.floorRemarkZh">
          <meta-info :title="$t('building_page.floorRemark')" :title-style="titleStyle" class="meta-info">
            <div slot="zh">
              <div v-for="remark in floorRemarkZh">
                {{ remark }}
              </div>
            </div>
            <div slot="en">
              <div v-for="remark in floorRemarkEn">
                {{ remark }}
              </div>
            </div>
          </meta-info>
        </div>
        
        <div class="col-xs-12" v-if="building.airConditioningOpeningTimes">
          <meta-info
            :title="$t('building_page.airConditioningOpeningTimes')"
            :title-style="titleStyle"
            class="lg-meta"
            v-if="openingTimes && openingTimes.length > 0"
          >
            <div slot="zh">
              <time-info v-for="(airConditioningTime, index) in openingTimes"
                 :airConditioningTime="airConditioningTime"
                 :key="index"></time-info>
            </div>
            <div slot="en">
              <time-info v-for="(airConditioningTime, index) in openingTimes" 
                  :airConditioningTime="airConditioningTime"
                  :key="index"></time-info>
            </div>
          </meta-info>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import timeUtils from '@/mixins/timeUtils';
  import numberFormat from '@/mixins/numberFormat';
  import MetaInfo from '@/components/MetaInfo';
  import LotInfoBox from '@/components/LotInfoBox';
  import TimeInfo from '@/components/TimeInfo';
  import yesIcon from '@/assets/icons/icon_Yes.svg';
  import noIcon from '@/assets/icons/icon_No.svg';

  export default {
    mixins: [timeUtils, numberFormat],
    components: {
      MetaInfo,
      LotInfoBox,
      TimeInfo,
    },
    props: ['pisBuildingId', 'unicornDistrict'],
    data() {
      return {
        building: {},
        buildingWithSource: {},
        district18: [
          {
            id: '1',
            nameZh: '中西區',
            nameEn: 'Central and Western',
          },
          {
            id: '2',
            nameZh: '灣仔區',
            nameEn: 'Wan Chai',
          },
          {
            id: '3',
            nameZh: '東區',
            nameEn: 'Eastern',
          },
          {
            id: '4',
            nameZh: '南區',
            nameEn: 'Southern',
          },
          {
            id: '5',
            nameZh: '油尖旺區',
            nameEn: 'Yau Tsim Mong',
          },
          {
            id: '6',
            nameZh: '深水埗區',
            nameEn: 'Sham Shui Po',
          },
          {
            id: '7',
            nameZh: '九龍城區',
            nameEn: 'Kowloon City',
          },
          {
            id: '8',
            nameZh: '黃大仙區',
            nameEn: 'Wong Tai Sin',
          },
          {
            id: '9',
            nameZh: '觀塘區',
            nameEn: 'Kwun Tong',
          },
          {
            id: '10',
            nameZh: '葵青區',
            nameEn: 'Kwai Tsing',
          },
          {
            id: '11',
            nameZh: '荃灣區',
            nameEn: 'Tsuen Wan',
          },
          {
            id: '12',
            nameZh: '屯門區',
            nameEn: 'Tuen Mum',
          },
          {
            id: '13',
            nameZh: '元朗區',
            nameEn: 'Yuen Long',
          },
          {
            id: '14',
            nameZh: '北區',
            nameEn: 'Northern',
          },
          {
            id: '15',
            nameZh: '大埔區',
            nameEn: 'Tai Po',
          },
          {
            id: '16',
            nameZh: '沙田區',
            nameEn: 'Sha Tin',
          },
          {
            id: '17',
            nameZh: '西貢區',
            nameEn: 'Sai Kung',
          },
          {
            id: '18',
            nameZh: '離島區',
            nameEn: 'Islands',
          },
        ],
        titleStyle: {
          color: '#a8a086',
        },
        yesIcon,
        noIcon,
      };
    },
    computed: {
      usage() {
        return Array.isArray(this.building.usage) ?
          this.building.usage.map(u => this.$t(`building_page.${u}Usage`)).toString() :
          null;
      },
      districtZh() {
        const found = this.district18.find(dist => dist.id === this.building.districtId);
        return found ? found.nameZh : '';
      },
      districtEn() {
        const found = this.district18.find(dist => dist.id === this.building.districtId);
        return found ? found.nameEn : '';
      },
      inTakeDate() {
        return this.building.inTakeDate ? this.str2time(this.building.inTakeDate).format('YYYY') : '---';
      },
      title() {
        if (this.building.title) {
          return this.$i18n.locale === 'en' ?
            this.$t(`building_page.${this.building.title}`, 'en') :
            this.$t(`building_page.${this.building.title}`);
        }
        return '---';
      },
      managementCompanyZh() {
        return this.building.managementCompanyZh ?
          `${this.building.managementCompanyZh}` :
          '---';
      },
      managementCompanyEn() {
        return this.building.managementCompanyEn ?
          `${this.building.managementCompanyEn}` :
          '---';
      },
      managementFeeZh() {
        if (this.building.managementFeeZh) {
          return this.building.managementFeeZh;
        }
        return '---';
      },
      managementFeeEn() {
        if (this.building.managementFeeEn) {
          return this.building.managementFeeEn;
        }
        return '---';
      },
      managementFeeSourceZh() {
        const t = this.buildingWithSource.managementFeeZh;
        if (t) {
          return t.sourceDate ? this.str2time(t.sourceDate).format('YYYY') : null;
        }
        return null;
      },
      managementFeeSourceEn() {
        const t = this.buildingWithSource.managementFeeEn;
        if (t) {
          return t.sourceDate ? this.str2time(t.sourceDate).format('YYYY') : null;
        }
        return null;
      },
      numberOfBuildingsZh() {
        return this.building.numberOfBuildings ?
          `${this.building.numberOfBuildings}座` :
          '---';
      },
      numberOfBuildingsEn() {
        return this.building.numberOfBuildings ?
          `${this.building.numberOfBuildings}` :
          '---';
      },
      numberOfFloorZh() {
        return this.building.numberOfFloors ?
          `${this.building.numberOfFloors}層` :
          '---';
      },
      numberOfFloorEn() {
        return this.building.numberOfFloors ?
          `${this.building.numberOfFloors}` :
          '---';
      },
      totalAreaZh() {
        return this.building.totalArea ?
          `約${this.fmt(this.building.totalArea)}呎` :
          '---';
      },
      totalAreaEn() {
        return this.building.totalArea ?
          `Approx. ${this.fmt(this.building.totalArea)} sq.ft.` :
          '---';
      },
      numberOfPassengerLiftZh() {
        return this.building.numberOfPassengerLift ?
          `${this.building.numberOfPassengerLift}部` :
          '---';
      },
      numberOfPassengerLiftEn() {
        return this.building.numberOfPassengerLift ?
          `${this.building.numberOfPassengerLift}` :
          '---';
      },
      numberOfCargoLiftZh() {
        return this.building.numberOfCargoLift ?
          `${this.building.numberOfCargoLift}部` :
          '---';
      },
      numberOfCargoLiftEn() {
        return this.building.numberOfCargoLift ?
          `${this.building.numberOfCargoLift}` :
          '---';
      },
      ceilingHeightZh() {
        return this.building.ceilingHeightZh ?
          `${this.building.ceilingHeightZh}` :
          '---';
      },
      ceilingHeightEn() {
        return this.building.ceilingHeightEn ?
          `${this.building.ceilingHeightEn}` :
          '---';
      },
      floorRemarkZh() {
        return this.building && this.building.floorRemarkZh ?
          this.building.floorRemarkZh.split('/n') :
          [];
      },
      floorRemarkEn() {
        return this.building && this.building.floorRemarkEn ?
          this.building.floorRemarkEn.split('/n') :
          [];
      },
      raisedFloorContent() {
        if (this.building.raisedFloor === 'checked') {
          return 'YES';
        }
        if (this.building.raisedFloor === 'unchecked') {
          return 'NO';
        }
        return 'noProvided';
      },
      loadingAreaContent() {
        if (this.building.loadingArea === 'checked') {
          return 'YES';
        }
        if (this.building.loadingArea === 'unchecked') {
          return 'NO';
        }
        return 'noProvided';
      },
      cargoContent() {
        if (this.building.cargo === 'checked') {
          return 'YES';
        }
        if (this.building.cargo === 'unchecked') {
          return 'NO';
        }
        return 'noProvided';
      },
      carParkContent() {
        if (this.building.carPark === 'checked') {
          return 'YES';
        }
        if (this.building.carPark === 'unchecked') {
          return 'NO';
        }
        return 'noProvided';
      },
      airConditioningType() {
        const temp = this.building.airConditioning.map(x => this.$t(`building_page.${x}`));
        return temp.join(',');
      },
      openingTimes() {
        const tempTime = this.building.airConditioningOpeningTimes ?
                         this.building.airConditioningOpeningTimes : [];
        const weekdays = [1, 6, 7];
        const output = weekdays.map(w => this.extractTime(tempTime[w - 1], w));
        return output;
      },
      airConditioningFeeZh() {
        return this.building.airConditioningFee ?
          `${this.building.airConditioningFee}` :
          '---';
      },
      airConditioningFeeEn() {
        return this.building.airConditioningFee ?
          `${this.building.airConditioningFee}` :
          '---';
      },
      noInfoDisplay() {
        if (Array.isArray(this.building.airConditioning)
        && this.building.airConditioning.length > 0) {
          return false;
        }
        if (Array.isArray(this.openingTimes)
        && this.openingTimes.length > 0) {
          return false;
        }
        if (this.building.airConditioningFee) {
          return false;
        }
        return true;
      },
      transportContentZh() {
        return this.building.transportZh ?
          `${this.building.transportZh}` :
          '---';
      },
      transportContentEn() {
        return this.building.transportEn ?
          `${this.building.transportEn}` :
          '---';
      },
    },
    methods: {
      extractTime(timeInfo, weekday) {
        let weekdayName;
        switch (weekday) {
          case 1: weekdayName = this.$t('building_page.MonToFri'); break;
          case 6: weekdayName = this.$t('building_page.Sat'); break;
          case 7: weekdayName = this.$t('building_page.Sun'); break;
          default: weekdayName = ''; break;
        }

        if (timeInfo) {
          return {
            weekday: weekdayName,
            start: timeInfo.start ? timeInfo.start : '',
            end: timeInfo.end ? timeInfo.end : '',
          };
        }
        return {
          weekday: weekdayName,
          start: '',
          end: '',
        };
      },
    },
    apollo: {
      building: {
        client: 'building',
        fetchPolicy: 'network-only',
        query: gql`
          query ($buildingId: ID!) {
            building(id: $buildingId) {
              id
              districtId
              usage
              grade
              inTakeDateFormat
              inTakeDate
              title
              lotInfo {
                landLeasesDateFormat
                landLeasesDate
                landLeases
                optionForRenewal
                lotId
                lotZh
                lotEn
              }
              managementCompanyZh
              managementCompanyEn
              managementFeeZh
              managementFeeEn
              transportZh
              transportEn
              numberOfFloors
              numberOfBuildings
              totalArea
              numberOfCargoLift
              numberOfPassengerLift
              ceilingHeightZh
              ceilingHeightEn
              floorRemarkZh
              floorRemarkEn
              raisedFloor
              loadingArea
              cargo
              carPark
              airConditioning
              airConditioningFee
              airConditioningOpeningTimes {
                weekday
                start
                end
              }
            }
          }
        `,
        variables() {
          return { buildingId: this.pisBuildingId };
        },
      },
      buildingWithSource: {
        client: 'building',
        fetchPolicy: 'network-only',
        query: gql`
          query ($buildingId: ID!) {
            buildingWithSource(id: $buildingId) {
              id
              managementFeeZh {
                sourceDate
                sourceName
                payload
              }
              managementFeeEn {
                sourceDate
                sourceName
                payload
              }
            }
          }
        `,
        variables() {
          return { buildingId: this.pisBuildingId };
        },
      },
    },
  };
</script>

<style scoped>
  .icon {
    width: 22px;
  }
  
  .management-fee-source {
    font-size: 12px;
    font-style: italic;
  }
  
  .sm-info-container {
    display: flex;
    flex-wrap: wrap;
  }
  
  .sm-info, .flex-info {
    width: 33.3%;
  }
  
  .remark-string {
    white-space: break-spaces;
    word-break: keep-all;
  }
  
  @media (max-width: 812px) { 
    .flex-info {
      width: 100%;
    }
    
    .meta-info, .meta-info-container {
      text-align: center;
    }
  }
</style>